import React from 'react';
import format from 'date-fns/format';
import {
  differenceInMilliseconds,
  areIntervalsOverlapping,
  sub,
  isWithinInterval,
} from 'date-fns';
import { Button, Fade } from 'react-bootstrap';
import { getContentImageByMode } from '../../../../utils/imageUtils';
import { LOADING_IMG } from '../../../../HOCs/ImageHocs';
import { IMAGE_MODE } from '../../../../constants/contentTypes';
// import ContentCard from '../../../ContentCard';

function EPGProgramItemBody({
  firstSwiper,
  selectedProgramItem,
  onClickContentSelected,
  epgItemCollection,
  translationTexts,
  currentTime,
  isContentSelected,
  isImgProgramItemBody,
  isDateInBody,
  contentNoImageProps,
  ContentCard,
  showPlayIcon,
}) {
  const [open, setOpen] = React.useState(false);
  const [disabled, setDisabled] = React.useState(false);
  const [buttonState, setButtonState] = React.useState(false);
  const [toSeeAgain, setToSeeAgain] = React.useState(false);
  const [selectedProgramItemR, setSelectedProgramItem] = React.useState({});
  const [bodyPositionTranslate, setBodyPositionTranslate] = React.useState(0);
  const [bodyPositionTransition, setBodyPositionTransition] = React.useState(0);

  const [currentTimeState, setCurrentTimeState] = React.useState(false);

  React.useEffect(() => {
    if (
      selectedProgramItemR?.startTime &&
      selectedProgramItemR?.endTime &&
      selectedProgramItemR?.startTime < selectedProgramItemR?.endTime
    ) {
      setCurrentTimeState(
        isWithinInterval(Date.now(), {
          start: new Date(selectedProgramItemR.startTime),
          end: new Date(selectedProgramItemR.endTime),
        }),
      );
    }
  }, [currentTime, selectedProgramItemR]);

  React.useEffect(() => {
    if (firstSwiper.on) {
      setBodyPositionTranslate(firstSwiper.translate);
      firstSwiper.on('setTranslate', (swiper, translate) => {
        setBodyPositionTranslate(translate);
      });
      firstSwiper.on('setTransition', (swiper, transition) => {
        setBodyPositionTransition(transition);
      });
    }
    return () => {
      firstSwiper.off('setTranslate');
      firstSwiper.off('setTransition');
    };
  }, [firstSwiper]);

  React.useEffect(() => {
    setOpen(false);
    setDisabled(false);

    let startTimeHasCatchUp = Date.parse(selectedProgramItem.startTime);
    const nowCall = Date.now();
    let buttonBool = false;

    if (epgItemCollection?.hasCatchUp) {
      startTimeHasCatchUp = Date.parse(
        sub(nowCall, { hours: epgItemCollection.catchUpHours }),
      );
      buttonBool = areIntervalsOverlapping(
        {
          start: Date.parse(selectedProgramItem?.startTime),
          end: Date.parse(selectedProgramItem?.endTime),
        },
        {
          start: startTimeHasCatchUp,
          end: nowCall,
        },
      );
    } else {
      buttonBool = areIntervalsOverlapping(
        { start: new Date(), end: new Date() },
        {
          start: Date.parse(selectedProgramItem.startTime),
          end: Date.parse(selectedProgramItem.endTime),
        },
      );
    }
    const millisecondsTotal = Math.abs(
      differenceInMilliseconds(
        new Date(),
        Date.parse(selectedProgramItem?.endTime),
      ),
    );
    const disabledTimeout = setTimeout(() => {
      setDisabled(true);
    }, millisecondsTotal);

    const selectedProgramItemTimeout = setTimeout(() => {
      setSelectedProgramItem(selectedProgramItem);
      setButtonState(buttonBool);
      setOpen(true);
      setToSeeAgain(
        epgItemCollection?.hasCatchUp &&
          !isWithinInterval(Date.now(), {
            start: new Date(selectedProgramItem?.startTime),
            end: new Date(selectedProgramItem?.endTime),
          }),
      );
    }, 300);

    return () => {
      clearTimeout(disabledTimeout);
      clearTimeout(selectedProgramItemTimeout);
    };
  }, [selectedProgramItem]);

  React.useEffect(() => {
    setSelectedProgramItem(selectedProgramItem);
  }, []);

  const imgBody =
    isImgProgramItemBody &&
    getContentImageByMode(selectedProgramItemR.images, IMAGE_MODE.THUMB)?.url;

  return (
    <div
      className={`epgGridList_row_itemBody epgGridList_row_itemBody_current_${currentTimeState}`}
      style={{
        position: 'relative',
        transform: `translate3d(${Math.abs(bodyPositionTranslate)}px, 0px, 0px)`,
        transitionDuration: `${bodyPositionTransition}ms`,
        transitionTimingFunction: 'ease-out',
        width: `${firstSwiper?.width}px`,
      }}
    >
      <Fade in={open} timeout={200}>
        {
          <div className="epgGridList_row_itemBody_container">
            {imgBody && (
              <ContentCard
                className="epgGridList_row_itemBody_contentCard"
                content={selectedProgramItemR}
                imageMode={IMAGE_MODE.THUMB}
                textMode={'none'}
                contentNoImageProps={contentNoImageProps}
                key={'epgGridList_row_itemBody_contentCard-' + imgBody}
                loading={LOADING_IMG.EAGER}
              />
            )}
            <div className="epgGridList_row_itemBody_text">
              {isDateInBody && (
                <div className="epgGridList_row_itemBody_date">
                  <div className="epgGridList_row_itemBody_time">
                    <i className="epgGridList_row_itemBody_time_icon bi bi-clock" />
                    {selectedProgramItemR?.startTime && (
                      <div className="epgGridList_row_itemBody_time_startTime">
                        {format(
                          Date.parse(selectedProgramItemR?.startTime),
                          'HH:mm',
                        )}
                      </div>
                    )}
                    <div className="epgGridList_row_itemBody_time_space">-</div>
                    {selectedProgramItemR?.endTime && (
                      <div className="epgGridList_row_itemBody_time_endTime">
                        {format(
                          Date.parse(selectedProgramItemR?.endTime),
                          'HH:mm',
                        )}
                      </div>
                    )}
                  </div>
                  {/* <div className=''></div> */}
                </div>
              )}

              <div className="epgGridList_row_itemBody_description">
                {selectedProgramItemR?.description}
              </div>
              {buttonState && isContentSelected && (
                <Button
                  className={`epgGridList_row_itemBody_button ${toSeeAgain ? 'watch-again' : ''}`}
                  disabled={disabled}
                  onClick={() =>
                    onClickContentSelected({
                      selectedProgramItemR,
                      epgItemCollection,
                    })
                  }
                >
                  {showPlayIcon && <i className="bi bi-play-fill"></i>}
                  <span className="epgGridList_row_itemBody_button_title">
                    {toSeeAgain
                      ? translationTexts?.to_see_again
                      : translationTexts?.see_channel_live}
                  </span>
                </Button>
              )}
            </div>
          </div>
        }
      </Fade>
    </div>
  );
}

export default React.memo(EPGProgramItemBody);
